// Bane 4: Køen (2041). Midtjylland omkring Viborg, Tjele, Foulum og Aarhus.
// Nyt: tilslutningskø med fantomer, datacenter-rush (reservér kapacitet eller vent og se) og
// hedebølger, hvor luftledningerne tåler mindre. Finalen: datacenter-rush midt i en hedebølge.
// Skagerrak lander ved Tjele, men forbindelsen til Norge er ikke med før bane 6.

import type { LevelDef } from '../../sim/types';

export const LEVEL_04: LevelDef = {
  id: '04-koeen',
  number: 4,
  title: 'Køen',
  year: 2041,
  intro: 'Alle vil have strøm til et datacenter. Nogle af dem findes kun på papir. Find ud af hvem.',
  view: [58, 118, 156, 194],
  greenGoalPct: 74,
  sites: [
    { node: 'viborg', kind: 'city', tier: 2, maxTier: 2 },
    { node: 'tjele', kind: 'station' },
    { node: 'hvam', kind: 'wind', name: 'Hvam Vind', capMw: 600, fee: 4 },
    { node: 'foulum', kind: 'plant', name: 'Biomasse-kraftvarme', capMw: 400, green: 1 },
    { node: 'bjerringbro', kind: 'city', tier: 0, maxTier: 2, at: [8, 15] },
    { node: 'ulstrup', kind: 'datacenter', name: 'Datacenter Ulstrup', baseMw: 150, at: [30, 40] },
    // Kunder i køen, i den rækkefølge de dukker op.
    { node: 'karup', kind: 'solar', name: 'Solpark Karup', capMw: 300, at: 'pool' },
    { node: 'silkeborg', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'thorning', kind: 'wind', name: 'Thorning Vind', capMw: 450, at: 'pool' },
    { node: 'studstrup', kind: 'plant', name: 'Studstrupværket', capMw: 700, green: 1, at: 'pool' },
    { node: 'randers', kind: 'city', tier: 0, maxTier: 2, at: 'pool' },
    { node: 'trige', kind: 'station', at: 'pool' },
    { node: 'aarhus', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    // Ikast og Ry ligger sydvest og sydøst for Silkeborg, hver for enden af en ny gren.
    { node: 'ikast', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'ry', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    // Datacenter-rush: kommer kun med hændelsen, og nogle er fantomer.
    { node: 'hammel', kind: 'datacenter', name: 'Datacenter Hammel', baseMw: 150, at: 'rush' },
    { node: 'hinnerup', kind: 'datacenter', name: 'Datacenter Hinnerup', baseMw: 150, at: 'rush' },
    { node: 'rodkaersbro', kind: 'datacenter', name: 'Datacenter Rødkærsbro', baseMw: 150, at: 'rush' },
    { node: 'laurbjerg', kind: 'datacenter', name: 'Datacenter Laurbjerg', baseMw: 150, at: 'rush' },
  ],
  // Tjele er koblet til Viborg med en 400 kV, og kraftvarmeværket ved Foulum hænger på Tjele.
  lines: [
    { a: 'tjele', b: 'viborg', medium: 'air', tier: 2 },
    { a: 'foulum', b: 'tjele', medium: 'air', tier: 1 },
  ],
  mechanics: ['air', 'upgrade', 'double', 'cable', 'crew', 'reinforce', 'station', 'shoo', 'battery', 'wishes', 'fcr', 'shed'],
  eventMenu: ['storm', 'digger', 'protest', 'heatwave'],
  // Ét nyt i hvert år: naboerne, hedebølgen og datacenter-køen (begge scriptet), gravkoen og stormen.
  news: [['protest'], ['heatwave'], ['dc_rush'], ['digger'], ['storm']],
  scripted: [
    // Den første hedebølge om sommeren i år 2, så kortet bliver vist, før det gælder.
    { kind: 'heatwave', at: [85, 95] },
    // Det første rush i starten af år 3, lige efter årsskiftet: to kunder vil på nettet, og en af dem er måske et fantom.
    { kind: 'dc_rush', at: [124, 132], strength: 2 },
    // Finalen: hedebølge, og midt i den vil tre datacentre på nettet samtidig.
    { kind: 'heatwave', at: 6, finale: true },
    { kind: 'dc_rush', at: 14, strength: 3, finale: true },
  ],
  growth: [],
  boosts: [],
  years: 5,
  finaleS: 40,
  clockFrozenUntilYear: 0,
  startCrews: 1,
  crewHome: 'viborg',
  packs: [
    ['town_meeting', 'two_crews'],
    ['free_air3', 'big_battery'],
    ['free_double', 'town_meeting'],
    ['two_crews', 'free_air3'],
    ['free_station', 'free_air3'],
  ],
};
